module.exports = __webpack_public_path__ + "img/mostly-cloudy.ce197d0.svg";